import type { HotelConstraint } from '@sembo-private/constraint-builder';
import { deserializeConstraint } from '@sembo-private/constraint-builder';

export function getBaseConstraint(searchText: string): HotelConstraint {
  const maxNumberOfHotels = 200;
  const constraint = deserializeConstraint(searchText);
  constraint.maxNumberOfHotels = maxNumberOfHotels;

  return constraint;
}
